import axios from 'axios';

import { FAILURE, REQUEST, SUCCESS } from 'app/shared/reducers/action-type.util';
import { ICategory, IGetCategories } from 'app/shared/model/categories-zones.model';

export const ACTION_TYPES = {
  FETCH_CATEGORIES: 'categories/FETCH_CATEGORIES',
  RESET: 'categories/RESET',
};

const initialState = {
  loading: false,
  data: null as IGetCategories,
  fetchSuccess: false,
  fetchError: false,
};

export type CategoriesState = Readonly<typeof initialState>;

// Reducer
export default (state: CategoriesState = initialState, action): CategoriesState => {
  switch (action.type) {
    case REQUEST(ACTION_TYPES.FETCH_CATEGORIES):
      return {
        ...state,
        fetchSuccess: false,
        loading: true,
      };

    case FAILURE(ACTION_TYPES.FETCH_CATEGORIES):
      return {
        ...state,
        loading: false,
        fetchSuccess: false,
        fetchError: true,
      };

    case SUCCESS(ACTION_TYPES.FETCH_CATEGORIES):
      return {
        ...state,
        loading: false,
        fetchSuccess: true,
        fetchError: false,
        data: action.payload.data,
      };

    case ACTION_TYPES.RESET:
      return {
        ...initialState,
      };
    default:
      return state;
  }
};

// Actions
export const getCategories = () => async dispatch => {
  await dispatch({
    type: ACTION_TYPES.FETCH_CATEGORIES,
    payload: axios.get(`api/categories`),
  });
};

export const reset = () => ({
  type: ACTION_TYPES.RESET,
});
